import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';

import { SharedUiComponentService } from '@nexweb/shared/abp/ui';

const CLOCK_FORMAT_KEY = 'sapptp-clock-format-24h';

@Component({
  standalone: true,
  selector: 'nexweb-sapptp-clock-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sapptp-clock-toggle.component.html',
  styleUrl: './sapptp-clock-toggle.component.scss',
})
export class SapptpClockToggleComponent implements OnInit {
  is24h = signal(false);

  private sharedUiService = inject(SharedUiComponentService);

  ngOnInit(): void {
    try {
      this.is24h.set(localStorage.getItem(CLOCK_FORMAT_KEY) === 'true');
    } catch {
      this.is24h.set(false);
    }
    this.sharedUiService.setUse24hClock(this.is24h());
  }

  onToggle(event: Event): void {
    this.is24h.set((event.target as HTMLInputElement).checked);
    try {
      localStorage.setItem(CLOCK_FORMAT_KEY, String(this.is24h()));
    } catch {
      // preference persistence is best-effort
    }
    this.sharedUiService.setUse24hClock(this.is24h());
  }
}
